function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71932 9.35721C8.13948 9.35721 9.29075 8.20594 9.29075 6.78578C9.29075 5.36562 8.13948 4.21436 6.71932 4.21436C5.29916 4.21436 4.14789 5.36562 4.14789 6.78578C4.14789 8.20594 5.29916 9.35721 6.71932 9.35721Z",
  stroke: "#ED0E78",
  strokeWidth: 0.919643,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8622 9.35714C9.93361 13.8571 6.71933 19 6.71933 19C6.71933 19 3.50504 13.8571 1.57647 9.35714C-0.352103 4.85714 2.86218 1 6.71933 1C10.5765 1 13.7908 4.85714 11.8622 9.35714Z",
  stroke: "#ED0E78",
  strokeWidth: 0.919643,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgRecent = function SvgRecent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recent.88e2ac6c.svg";
export { ForwardRef as ReactComponent };